import React from "react";
import { Globe } from "lucide-react";

interface DefaultIconProps {
  label: string;
  className?: string;
}

export const CRMDefaultIcon = ({ label, className }: DefaultIconProps) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="50" cy="50" r="45" fill="#449995" />
    <text
      x="50"
      y="50"
      font-family="Arial, sans-serif"
      font-size="32"
      font-weight="bold"
      text-anchor="middle"
      dominant-baseline="middle"
      fill="white"
    >
      CRM
    </text>
  </svg>
);

export const DMSDefaultIcon = ({ label, className }: DefaultIconProps) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="50" cy="50" r="45" fill="#449995" />
    <text
      x="50"
      y="50"
      font-family="Arial, sans-serif"
      font-size="32"
      font-weight="bold"
      text-anchor="middle"
      dominant-baseline="middle"
      fill="white"
    >
      DMS
    </text>
  </svg>
);

export const WebsiteDefaultIcon = ({ label, className }: DefaultIconProps) => (
  <div className="w-full h-full flex items-center justify-center">
    <Globe size={40} color="#449995" strokeWidth={1.5} className={className} />
  </div>
);
